import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Airport, Destination, UserDeparture, UserDepartureUpdate} from '../models/AirportModel';
import {Observable} from 'rxjs';


const AIRPORTS_URL = '/api/airports';
const DESTINATIONS_URL = '/api/destinations';
@Injectable({
    providedIn: 'root'
})
export class AirportsService {

    constructor(private http: HttpClient) {
    }

    getUsersDepartures(): Observable<UserDeparture[]> {
        return this.http.get<UserDeparture[]>(`${AIRPORTS_URL}/me`, {withCredentials: true});
    }

    getUsersDestinations(): Observable<Destination[]> {
        return this.http.get<Destination[]>(`${DESTINATIONS_URL}/me`, {withCredentials: true});
    }

    searchAirports(search: string): Observable<Airport[]> {
        return this.http.get<Airport[]>(AIRPORTS_URL, {params: { search }, withCredentials: true});
    }

    setAirport(airportID: number): Observable<UserDeparture[]> {
        return this.http.post<UserDeparture[]>(`${AIRPORTS_URL}/me`, {id: airportID}, {withCredentials: true});
    }

    updateDeparture(airportID: number, update: UserDepartureUpdate): Observable<UserDeparture[]> {
        return this.http.put<UserDeparture[]>(`${AIRPORTS_URL}/me/${airportID}`, update, {withCredentials: true});
    }

    searchDestinations(search: string): Observable<Destination[]> {
        return this.http.get<Destination[]>(DESTINATIONS_URL, {params: {search}, withCredentials: true});
    }

    setDestination(destination: {id: number}[]): Observable<void> {
        return this.http.post<any>(`${DESTINATIONS_URL}/me`, {destination}, {withCredentials: true});
    }

    removeDestination(destination: number): Observable<void> {
        return this.http.delete<void>(`${DESTINATIONS_URL}/${destination}`, { withCredentials: true});
    }

    findPopularDestinationsBasedOnDeparture():Observable<Destination[]> {
        return this.http.get<any>(`${DESTINATIONS_URL}/me/popular`, {withCredentials: true});
    }

    findAirportsBasedOnIP(lat?: number, lon?: number): Observable<Airport[]> {
        let params = new HttpParams();
        if (lat !== undefined && lat !== null) {
            params = params.set('lat', lat.toString());
        }
        if (lon !== undefined && lon !== null) {
            params = params.set('lon', lon.toString());
        }
        return this.http.get<Airport[]>(`${AIRPORTS_URL}/nearest`, {params, withCredentials: true});
    }

    public getIPLocation(): Promise<GeolocationPosition> {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position: GeolocationPosition) => resolve(position),
                    (error: GeolocationPositionError) => {
                        reject(error)
                        },
            { timeout: 10000 }
                );
            } else {
                reject(new Error('Geolocation is not supported by this browser.'));
            }
        });
    }

    removeAirport(airport: number): Observable<UserDeparture[]> {
        return this.http.delete<UserDeparture[]>(`${AIRPORTS_URL}/${airport}`, {withCredentials: true});
    }

    //todo figure out return type and if we're even keeping this functionality
    getUnsplashPhoto(query: string): Observable<any> {
        return this.http.get<any>(`${DESTINATIONS_URL}/unsplash`, {params: {query}, withCredentials: true});
    }

    getRecommendedAirports(): Observable<Airport[]> {
        return this.http.get<Airport[]>(`${AIRPORTS_URL}/me/recommended`, {withCredentials: true});
    }


}
